<form [formGroup]="documentForm">


    <div class="col-md-12">
        <div class="tile">
            <h3 class="tile-title">{{title}}</h3>
            <div class="tile-body">
                <div class="form-group">
                    <label class="control-label">Name</label>
                    <input formControlName="Name" class="form-control" type="text" placeholder="Enter full name">
                </div>
                <div class="form-group">
                    <label class="control-label">Document Type</label>
                    <select formControlName="ApplicationDocumentTypeId" class="form-control">
                        <option value="">Select type</option>
                        <option *ngFor="let item of types" value="{{item.ValueId}}">
                            {{item.DisplayValue}}

                    </select>
                </div>

                <div class="form-group">
                    <label class="control-label">Select Document</label>
                    <input formControlName="FilePath" (change)="onSelectFile($event)" class="form-control" type="file">
                </div>

                <div class="form-group">
                    <label class="control-label">Description</label>
                    <textarea formControlName="Description" class="form-control" rows="4"
                        placeholder="Enter desc"></textarea>
                </div>


            </div>
            <div class="tile-footer">
                <a class="btn btn-secondary" href="javascript:void(0);" mat-dialog-close><i
                        class="fa fa-fw fa-lg fa-times-circle"></i>Cancel</a>

                &nbsp;&nbsp;&nbsp;

                <button [disabled]="!documentForm.valid" (click)="onUpload()" class="btn btn-primary" type="button"
                    [mat-dialog-close]="true" cdkFocusInitia><i
                        class="fa fa-fw fa-lg fa-check-circle"></i>Upload</button>


            </div>
        </div>
    </div>
</form>